import { Map } from 'immutable';

import {
  GET_CONTRACT_IMAGE_FACE_FRONT_REQUEST,
  GET_CONTRACT_IMAGE_FACE_FRONT_FAILURE,
  GET_CONTRACT_IMAGE_FACE_FRONT_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === GET_CONTRACT_IMAGE_FACE_FRONT_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], {});
  }

  if (type === GET_CONTRACT_IMAGE_FACE_FRONT_FAILURE) {
    return state.updateIn(['type'], () => type);
  }

  if (type === GET_CONTRACT_IMAGE_FACE_FRONT_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
